import { useTicketTypesByGroupIdSubscriber } from '../../services/store';

// We want [0] as we don't need the actions from the subscriber
const useGetTicketTypesByGroup = (groupId: number) => useTicketTypesByGroupIdSubscriber(groupId)[0];

export default useGetTicketTypesByGroup;
